import { Asset } from '@/api/generatedApi';
import { BulkLabelModal } from './BulkLabelModal';

export const LabelAssetModal = ({
  asset,
  open,
  onClose,
  onComplete,
}: {
  asset: Asset;
  open: boolean;
  onClose: () => void;
  onComplete?: () => void;
}) => (
  <BulkLabelModal
    selectedContent={[{ ...asset, contentType: 'asset' }]}
    open={open}
    onClose={onClose}
    onLabelComplete={onComplete}
  />
);
